/**
 * Canonical i18n namespace ids for the compliance frontend.
 *
 * Kept standalone (no i18next init, no registry icons) so `i18n.js` and
 * `appModuleValidate.js` can validate namespaces without circular imports or
 * bloating the `/login` cold-start bundle.
 *
 * ## When adding a namespace
 *
 * 1. Append the id to `ALL_NAMESPACES` below.
 * 2. Add `{namespace}.json` under every `public/locales/{language}/` directory.
 * 3. Reference it from the module's `i18n.namespaces` in `appModuleDefinitions.js`
 *    (or `NON_MODULE_ROUTE_I18N` in `appModuleI18n.js` for public/legacy routes).
 *
 * @module i18nNamespaces
 * @see docs/translate/preload.md
 * @see docs/translate/adding-translation-files.md
 */

/** Every namespace that must exist per configured language. */
export const ALL_NAMESPACES = [
  "analyzer",
  "common",
  "actions",
  "ai",
  "calendar",
  "configuration",
  "contracts",
  "copy",
  "dashboard",
  "entities",
  "evaluations",
  "fileTree",
  "files",
  "filter",
  "formats",
  "frameworks",
  "fromTemplate",
  "globalSearch",
  "login",
  "mobileDashboard",
  "newFramework",
  "notFound",
  "obligationDetails",
  "obligations",
  "obligationsV2",
  "references",
  "terms",
  "validations",
];
